import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LinuxServerCreateComponent} from './linux-server-create/linux-server-create.component';
import {FuseSharedModule} from '../../../../@fuse/shared.module';
import {FuseWidgetModule} from '../../../../@fuse/components';
import {KluhSharedModule} from '../../kluh-shared.module';
import {LinuxServerDaoService} from './linux-server-dao.service';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatIconModule} from '@angular/material/icon';
import {MatDialogModule} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {LinuxServerCreateTokenComponent} from './linux-server-create-token/linux-server-create-token.component';
import {MatCardModule} from '@angular/material/card';

@NgModule({
    imports: [
        CommonModule,
        FuseSharedModule,
        // RouterModule.forChild(routes),
        FuseWidgetModule,
        KluhSharedModule,
        MatSelectModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatToolbarModule,
        MatDialogModule,
        MatSlideToggleModule,
        MatCardModule
    ],
    declarations: [LinuxServerCreateComponent, LinuxServerCreateTokenComponent, LinuxServerCreateTokenComponent],
    providers: [
        LinuxServerDaoService
    ],
    entryComponents: [
        LinuxServerCreateComponent
    ]
})
export class LinuxServerModule {
}
